import { useQuery } from "@apollo/client";
import { useCallback, useState } from "react";
import { Card, CardBody, CardFooter, CardHeader, CloseButton, Spinner } from "reactstrap";
import { GET_GLOBAL_CATEGORIES } from "../../../graphql/org-gql";
import { ISecurityRole } from "../../../types/auth";
import { ICategory, IGlobalCategoriesResponse, IOrg, getOrgName } from "../../../types/org";
import { IAssignedRole } from "../../../types/user";
import { CheckIcon } from "../../common/icons";
import OrgTree from "../../common/org-tree/org-tree";
import './style.scss';
import Button from "../../common/button";

// sets scope for the given role
const OrgSelectionPanel = (props: {
  securityRole: ISecurityRole,
  onComplete: (role: IAssignedRole | undefined) => void
}) => {
  const { securityRole, onComplete } = props;

  const { loading, data } = useQuery<IGlobalCategoriesResponse>(GET_GLOBAL_CATEGORIES);

  const [selectedOrg, setSelectedOrg] = useState<ICategory | IOrg | undefined>();

  const handleConfirm = useCallback(() => {
    const newRole = {
      userRoleTypeId: securityRole.id
    } as IAssignedRole;

    if (selectedOrg) {
      newRole.orgScope = {
        id: selectedOrg?.id ?? 0,
        name: getOrgName(selectedOrg) ?? ''
      }
    }

    onComplete(newRole);

    // reset
    setSelectedOrg(undefined);
  }, [securityRole, selectedOrg]);

  return (
    <Card>
      <CardHeader>
        Please select which organization this user will be the <b>{securityRole?.name}</b> of.
        <CloseButton className="float-end" onClick={() => onComplete(undefined)} />
      </CardHeader>
      <CardBody className="org-selector-panel">
        {loading && <Spinner />}
        {data &&
          <OrgTree roots={data?.globalCategories ?? []} onSelected={setSelectedOrg} isGlobal={true} selectOrgOnly={true} />
        }
      </CardBody>
      <CardFooter className="d-flex justify-content-end">
        <Button color="primary" onClick={handleConfirm} disabled={!selectedOrg}>
          <CheckIcon /> Confirm
        </Button>
      </CardFooter>
    </Card>
  );
};

export default OrgSelectionPanel;
